import React, { useState } from 'react';

// Components
import { WpModal, WpModalBody, WpModalFooter, WpModalHeader } from '..';
import { WpButton, WpButtonGroup } from '../../button';

const ModalsDocs = () => {
  const sizes = ['sm', 'md', 'lg'] as const;

  const [modalSizeIsOpen, setModalSizeIsOpen] = useState(null);
  const [isFullModalOpen, setIsFullModalOpen] = useState(false);

  const toggleFullPageModal = () => setIsFullModalOpen(!isFullModalOpen);

  const handleOpenClick = size => setModalSizeIsOpen(size);

  const handleCloseClick = () => setModalSizeIsOpen(null);

  return (
    <>
      <h5 className="mt-3">Sizes</h5>
      <WpButtonGroup>
        {sizes.map(size => (
          <>
            <WpButton onClick={() => handleOpenClick(size)}>Size: {size}</WpButton>
            <WpModal isOpen={size === modalSizeIsOpen} size={size} onToggle={handleCloseClick}>
              <WpModalHeader>Modal Title</WpModalHeader>
              <WpModalBody>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum. Section 1.10.32 of de Finibus Bonorum et M? Lorem ipsum dolor sit
                amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
                laborum. Section 1.10.32 of de Finibus Bonorum et M? Lorem ipsum dolor sit amet, consectetur adipiscing
                elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Section 1.10.32
                of de Finibus Bonorum et M? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Section 1.10.32 of de Finibus
                Bonorum et M? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa
                qui officia deserunt mollit anim id est laborum. Section 1.10.32 of de Finibus Bonorum et M? Lorem ipsum
                dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim
                id est laborum. Section 1.10.32 of de Finibus Bonorum et M? Lorem ipsum dolor sit amet, consectetur
                adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
                sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                Section 1.10.32 of de Finibus Bonorum et M?
              </WpModalBody>
              <WpModalFooter>
                <WpButtonGroup>
                  <WpButton variant="tertiary">Share with Team</WpButton>
                  <WpButton>Edit</WpButton>
                </WpButtonGroup>
              </WpModalFooter>
            </WpModal>
          </>
        ))}
        <WpButton onClick={() => toggleFullPageModal()}>Size: full</WpButton>
        <WpModal isOpen={isFullModalOpen} size="full" onToggle={toggleFullPageModal}>
          <div className="container">
            <div className="d-flex justify-content-between align-items-center pt-5">
              <h5>Full Page Modal</h5>
              <WpButton onClick={toggleFullPageModal}>Close Modal</WpButton>
            </div>
            <hr />
            <div>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
              ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum. Section 1.10.32 of de Finibus Bonorum et M? Lorem ipsum dolor sit amet,
              consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
              minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
              irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
              sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              Section 1.10.32 of de Finibus Bonorum et M? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
              do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Section 1.10.32 of
              de Finibus Bonorum et M? Lorem ipsum
            </div>
          </div>
        </WpModal>
      </WpButtonGroup>
    </>
  );
};
export default ModalsDocs;
